





























import Vue from 'vue';

import Survey from '@/pages/survey/components/Survey.vue';

import { mapGetters } from '@/state/modules/survey_builder';

export default Vue.extend({
  name: 'Preview',
  components: {
    Survey,
  },
  computed: {
    ...mapGetters(['previewSurveyData', 'activeQuestionId', 'currentPage']),
  },
  mounted() {
    // nextTick is not enough because Survey.created() must be called and
    // promise needs to be resolved
    setTimeout(() => {
      const survey = this.$refs.survey as any;

      if (survey == null) {
        // this can happen if component is destroyed right after it
        // is mounted (in the same tick)
        return;
      }

      const question =
        this.activeQuestionId == null
          ? null
          : this.previewSurveyData.questions.find(question => question.id === this.activeQuestionId);

      if (question != null && question.conditions.length === 0) {
        survey.goToQuestion(question);
      } else {
        survey.goToPage(this.currentPage - 1);
      }
      survey.populateDirty(false);
    }, 0);
  },
});
